import gql from 'graphql-tag';

export const CcpEntitlementIdQuery = gql`
	query CcpEntitlementIdQuery {
		confluence_tenantContext {
			licenseStates {
				confluence {
					ccpEntitlementId
				}
			}
		}
	}
`;
